import { Subject, SellerData } from './subject.interfaces';

export const SELLER_BROKER_VOID: Subject = {
    _id: '',
    code: '',
    displayName: '',
    cuit: '',
};

export const SELLER_DATA_VOID: SellerData = {
    codeS: 0,
    sucG: 0,
    cuit: '',

    //proposalType: 0,
    //broker: SELLER_BROKER_VOID,
};
